import { createAppStore } from '@quadralize/utils'

export const useAppStore = createAppStore({
  name: 'backoffice-store',
  extraClasses: ['theme-backoffice'],
})
